export const GraphColors = {
  diseaseBorder: "#FF732B",
  nodeBackground: "#CEE4E8",
  findingBackground: "#7ECCFA",
  findingSubtypeBackground: "#A0EFFD",
  edgeBackground: "#b6ccd0",
  edgeBackgroundLight: "#d8eef2",
  nodeText: "#187C92",
  diseaseText: "#FF892D",
  selectionDark: "#09778E",
};
